// Imports
var ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___ = require("../../../../node_modules/html-loader/dist/runtime/getUrl.js");
var ___HTML_LOADER_IMPORT_0___ = require("../../../assets/forbidden_page.svg");
// Module
var ___HTML_LOADER_REPLACEMENT_0___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_0___);
var code = "<div class=\"forbidden\"> <img src=\"" + ___HTML_LOADER_REPLACEMENT_0___ + "\"> <p class=\"forbidden-main-text\">{{vm.line1}} </p><p data-ng-if=\"vm.domain\">{{vm.line2}}</p> <p data-ng-repeat=\"email in vm.adminEmailList track by $index\"> <a data-ng-href=\"mailto:{{email}}\" class=\"eva-link-primary\">{{email}}</a> </p> </div> ";
// Exports
module.exports = code;